import { ArrowBack, ArrowForward, Save } from "@mui/icons-material";
import {
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  Paper,
  Typography,
  Fab,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import Navbar from "../../Navbar";
export const RRHH2Form = ({ title, onSubmit, onClose, disabled,colorEmpresa, children }) => {
  return (
    <Container maxWidth="xl" disableGutters sx={{ px: { xs: 0.5, sm: 1, md: 2 } }}>
      <Box component="form" onSubmit={onSubmit}>
        <Navbar />
        <Paper
          elevation={0}
          sx={{
            my: 1,
            mb: 2,
            border: "1px solid rgba(21, 101, 192, 0.12)",
            borderRadius: "8px",
            overflow: "hidden",
            bgcolor: "background.paper",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            animation: "slideIn 0.4s ease-out",
            "@keyframes slideIn": {
              "0%": { opacity: 0, transform: "translateY(10px)" },
              "100%": { opacity: 1, transform: "translateY(0)" },
            },
            "&:hover": {
              boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
              borderColor: "rgba(21, 101, 192, 0.3)",
            },
          }}
        >
          <Box
            sx={{
              flexGrow: 1,
              background: `linear-gradient(135deg, ${colorEmpresa} 0%, rgba(0,0,0,0.2) 100%)`,
              backgroundColor: colorEmpresa,
              mb: 1,
              p: 1.5,
              position: 'relative',
              overflow: 'hidden',
              '&::after': {
                content: '""',
                position: 'absolute',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                background: 'radial-gradient(circle at top right, rgba(255,255,255,0.1), transparent 40%)',
                pointerEvents: 'none',
              }
            }}
          >
            <Grid container alignItems="center">
              {onClose && (
                <Grid item sx={{ position: 'absolute', left: 16 }}>
                  <IconButton
                    onClick={() => onClose()}
                    size="small"
                    sx={{
                      color: grey[50],
                      bgcolor: 'rgba(255,255,255,0.1)',
                      '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' }
                    }}
                  >
                    <ArrowBack fontSize="small" />
                  </IconButton>
                </Grid>
              )}
              <Grid item xs={12}>
                <Typography
                  variant="h6"
                  color="#fff"
                  textAlign="center"
                  sx={{
                    fontWeight: 600,
                    letterSpacing: '0.5px',
                    textTransform: 'uppercase',
                    fontSize: '1.1rem'
                  }}
                >
                  {title}
                </Typography>
              </Grid>
            </Grid>
          </Box>
          <Box sx={{ px: { xs: 1, sm: 1.5, md: 2 }, py: 1, pb: 7 }}>{children}</Box>
        </Paper>

        {/* Floating Action Button */}
        <Fab
          type="submit"
          color="primary"
          disabled={disabled}
          sx={{
            position: 'fixed',
            bottom: { xs: 16, md: 32 },
            right: { xs: 16, md: 32 },
            boxShadow: '0 6px 24px rgba(0,118,255,0.5)',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            animation: 'pulse 2s ease-in-out infinite',
            '@keyframes pulse': {
              '0%, 100%': { transform: 'scale(1)' },
              '50%': { transform: 'scale(1.05)' },
            },
            '&:hover': {
              boxShadow: '0 8px 32px rgba(0,118,255,0.6)',
              transform: 'scale(1.1) rotate(5deg)',
            },
            '&:active': {
              transform: 'scale(0.95)',
            },
          }}
        >
          <Save />
        </Fab>
      </Box>
    </Container>
  );
};
